module.exports = __webpack_public_path__ + "media/img/frontend_application/logs-blank-d054def6c0dd26630c759765531a0c99.png";